import { gql } from '@apollo/client';
import { messageHeaders } from 'features/common/fragments';

export const MARKED_AS_NOT_RENEWABLE = gql`
  subscription markedAsNotRenewable {
    markedAsNotRenewable {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_RENEWAL_OFFER_CREATED = gql`
  subscription insuranceRenewalOfferCreated($renewalDocumentId: Int!) {
    insuranceRenewalOfferCreated(renewalDocumentId: $renewalDocumentId) {
      documentId
      documentNumber
      documentStateName
      renewalDocumentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_OFFER_CREATION_FAILED = gql`
  subscription insuranceOfferCreationFailed($renewalDocumentId: Int!) {
    insuranceOfferCreationFailed(renewalDocumentId: $renewalDocumentId) {
      errorMessage
      renewalDocumentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const GENERATE_RENEWAL_OFFERS_COMPLETED = gql`
  subscription generateRenewalOffersCompleted {
    generateRenewalOffersCompleted {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const MARKED_AWAITING_CLIENT_RESPONSE = gql`
  subscription markedAwaitingClientResponse($documentId: Int!) {
    markedAwaitingClientResponse(documentId: $documentId) {
      documentId
      sentToClientDate
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const MARKED_AWAITING_CLIENT_RESPONSE_COMPLETED = gql`
  subscription markedAwaitingClientResponseCompleted {
    markedAwaitingClientResponseCompleted {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const RECOMPUTE_RENEWAL_QUOTATIONS_COMPLETED = gql`
  subscription recomputeRenewalQuotationsCompleted {
    recomputeRenewalQuotationsCompleted {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_DOCUMENT_COMMENTS_UPDATED = gql`
  subscription insuranceDocumentCommentsUpdated($documentId: Int!) {
    insuranceDocumentCommentsUpdated(documentId: $documentId) {
      documentId
      comments
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const COMPUTE_QUOTATIONS_FAILED = gql`
  subscription computeQuotationsFailed($renewalDocumentId: Int!) {
    computeQuotationsFailed(renewalDocumentId: $renewalDocumentId) {
      documentId
      renewalDocumentId
      message
      payload
      isComposite
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
